module.exports = __webpack_public_path__ + "img/Mitglied-BDVT.53c2f7e1.jpg";